import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { ContactForm } from "./contact.form";
import { useSaveData } from "../../../../../../hooks/useSaveData";
import { planReviewContactFormSchema } from "./contact-form.schema";
import { MutationKeyConfig } from "../../../../../../api/api-helper";
import { InvalidateRoute } from "../../../../../../hooks/useDeleteData";
import { useReactHookForm } from "../../../../../../hooks/useReactHookForm";
import { ReactHookForm } from "../../../../../../components/hook-form/react-hook-form.component";
import { useAuthorize } from "../../../../../../hooks/use-authorize";
import { UserPermissionName } from "../../../../../../models/user-permission-name";

interface EditContactDialog {
    data: any;
    onClosed: () => void;
    config: { saveConfig: MutationKeyConfig; invalidateRoute?: InvalidateRoute };
}
export const EditContactDialog = ({ data, onClosed, config: { saveConfig, invalidateRoute } }: EditContactDialog) => {

    const form = useReactHookForm({
        defaultValues: {
            ...data,
            contactRole: { contactsRoleID: data?.contactsRoleID ?? '', contactsRoleName: data?.contactsRoleName ?? '' }
        },
        yupSchema: planReviewContactFormSchema
    });

    const { isLoading, isError, error, mutateAsync } = useSaveData(saveConfig, invalidateRoute);

    const submitHanlder = async (value: any) => {
        const extendedValue = {
            ...value,
            contactsRoleID: value?.contactRole?.contactsRoleID,
            contactsRoleName: value?.contactRole?.contactsRoleName
        };
        await mutateAsync({ data: extendedValue });
        onClosed();
    };

    const handleSubmitClick = () => {
        form.handleSubmit(submitHanlder)();
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={'lg'}
        //  onClose={onClosed}
        >
            <DialogTitle id="form-dialog-title">Edit Contact</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 15,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <ReactHookForm formName="EDIT_CONTACT_PLAN_TASK_FORM" onSubmit={submitHanlder} formContextProps={form} isBusy={isLoading}>
                <DialogContent dividers className="popupDilog">
                    <ContactForm />
                </DialogContent>
                <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
                    <DialogActions className="spaceBetween">
                        <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                            Cancel
                        </Button>
                        <Button type="button" variant="contained" style={{ width: '130px' }} onClick={handleSubmitClick}
                            disabled={isReadOnlyPermission}>
                            Save
                        </Button>
                    </DialogActions>
                </div>
            </ReactHookForm>
        </Dialog>
    );
}